/* eslint-disable global-require */
import moment from 'moment'
import moment_de from 'moment/locale/de'
import moment_en_gb from 'moment/locale/en-gb'
import moment_es_us from 'moment/locale/es-us'
import moment_es from 'moment/locale/es'
import moment_fi from 'moment/locale/fi'
import moment_fr from 'moment/locale/fr'
import moment_it from 'moment/locale/it'
import moment_nl_be from 'moment/locale/nl-be'
import moment_nl from 'moment/locale/nl'
import moment_pt from 'moment/locale/pt'

export const updateMomentLocale = (deviceLocale) => {
  const [lang, region] = deviceLocale.split('_')
  switch (lang) {
    case 'de':
      moment.updateLocale(lang, moment_de)
      break
    case 'en':
      if (region && (region.toUpperCase() === 'GB' || region.toUpperCase() === 'IE')) {
        moment.updateLocale(lang, moment_en_gb)
      } else {
        moment.updateLocale(lang, {})
      }
      break
    case 'es':
      if (region && (region.toUpperCase() === 'US')) {
        moment.updateLocale(lang, moment_es_us)
      } else {
        moment.updateLocale(lang, moment_es)
      }
      break
    case 'fi':
      moment.updateLocale(lang, moment_fi)
      break
    case 'fr':
      moment.updateLocale(lang, moment_fr)
      break
    case 'it':
      moment.updateLocale(lang, moment_it)
      break
    case 'nl':
      if (region && (region.toUpperCase() === 'BE')) {
        moment.updateLocale(lang, moment_nl_be)
      } else {
        moment.updateLocale(lang, moment_nl)
      }
      break
    case 'pt':
      moment.updateLocale(lang, moment_pt)
      break
    default:
      moment.updateLocale('en', {})
  }
}

export const translations = {
  de: require('./de.json'),
  en_GB: require('./en_GB.json'),
  en_IE: require('./en_GB.json'),
  en: require('./en.json'),
  es_US: require('./es_US.json'),
  es: require('./es.json'),
  fi: require('./fi.json'),
  fr: require('./fr.json'),
  it: require('./it.json'),
  nl_BE: require('./nl_BE.json'),
  nl: require('./nl.json'),
  pt: require('./pt.json'),
}
export const availableLanguages = {
  de: 'de',
  en_GB: 'en_GB',
  en_IE: 'en_GB',
  en: 'en',
  es_US: 'es_US',
  es: 'es',
  fi: 'fi',
  fr: 'fr',
  it: 'it',
  nl_BE: 'nl_BE',
  nl: 'nl',
  pt: 'pt',
}
